import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-5" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref } from "vue";
import UserService from "../../services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { ElLoading } from "element-plus";
import notification from "@/core/plugins/notification";

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoAssignModal',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const autoAssignSwitch = ref(false);
const uId = ref<any>(null);
const isLoading = ref(false);
const show = async () => {
  dialogRef.value = true;
  await fetchData();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await UserService.getLeadsAutoAssignSetting();
    autoAssignSwitch.value = res.enabled;
    uId.value = res.autoAssignAccountUid;
  } catch (e) {
    console.log(e);
    MsgPrompt.error(e);
  }
  isLoading.value = false;
};

const switchAutoAssign = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });

  try {
    if (autoAssignSwitch.value == true)
      await UserService.enableLeadAutoAssign();
    else await UserService.disableLeadAutoAssign();
    notification.success();
  } catch (e) {
    console.log(e);
    MsgPrompt.error(e);
  }

  loading.close();
};

const changeLeadAutoAssignUid = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });

  try {
    await UserService.changeLeadAutoAssignUid({
      autoAssignAccountUid: uId.value,
    });
    notification.success();
  } catch (e) {
    console.log(e);
    MsgPrompt.error(e);
  }

  loading.close();
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.autoAssignSetting'),
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: uId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uId).value = $event)),
            placeholder: "Auto Assign Account UID",
            class: "mb-3"
          }, {
            prepend: _withCtx(() => [
              _createTextVNode("Account UID")
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: changeLeadAutoAssignUid
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_switch, {
            size: "large",
            modelValue: autoAssignSwitch.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((autoAssignSwitch).value = $event)),
            "active-text": "Enabled",
            "inactive-text": "Disabled",
            "active-color": "#13ce66",
            "inactive-color": "#ff4949",
            onChange: switchAutoAssign
          }, {
            open: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("status.enabled")), 1)
            ]),
            close: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("status.disabled")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})